import { render } from "./FinalCTA.vue?vue&type=template&id=1938e7cc&scoped=true"
import script from "./FinalCTA.vue?vue&type=script&lang=js"
export * from "./FinalCTA.vue?vue&type=script&lang=js"

import "./FinalCTA.vue?vue&type=style&index=0&id=1938e7cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1938e7cc"]])

export default __exports__